import React from 'react';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';
interface TiltCardProps {
  children: React.ReactNode;
  className?: string;
  /** Intensidad máxima de la inclinación en grados. */
  intensity?: number;
}

/**
 * Inclinación 3D suave siguiendo el cursor. Solo transforma (sin filtros ni
 * gradientes que repinten en cada movimiento del mouse) y se desactiva en
 * pantallas táctiles.
 */
export function TiltCard({
  children,
  className,
  intensity = 6
}: TiltCardProps) {
  const x = useMotionValue(0.5);
  const y = useMotionValue(0.5);
  const rotateX = useSpring(useTransform(y, [0, 1], [intensity, -intensity]), {
    stiffness: 150,
    damping: 20
  });
  const rotateY = useSpring(useTransform(x, [0, 1], [-intensity, intensity]), {
    stiffness: 150,
    damping: 20
  });
  const handleMove = (event: React.MouseEvent<HTMLDivElement>) => {
    const bounds = event.currentTarget.getBoundingClientRect();
    x.set((event.clientX - bounds.left) / bounds.width);
    y.set((event.clientY - bounds.top) / bounds.height);
  };
  const handleLeave = () => {
    x.set(0.5);
    y.set(0.5);
  };
  return <div className="h-full [perspective:1200px]" data-id="element-188" data-mp="ovwiz4739aaa">
      <motion.div onMouseMove={handleMove} onMouseLeave={handleLeave} style={{
      rotateX,
      rotateY
    }} className={`group relative h-full ${className ?? ''}`} data-id="element-189" data-mp="twu0dek9y0aq">
        {children}
      </motion.div>
    </div>;
}